import EnterCarDetails from "./images/enterCarDetails.jpg";
import FinalOfferInstantly from "./images/finalOfferInstantly.jpg";
import PickupPayment from "./images/pickupPayment.jpg";

export const STEPS = [
    {
        img: EnterCarDetails,
        title: "01",
        subTitle: "Get price online",
        description: "Answer some questions about your car to help us understand its condition"
    },
    {
        img: FinalOfferInstantly,
        title: "02",
        subTitle: "Car inspection",
        description: "Our car expert will physically verify your car’s condition and give you the final offer"
    },
    {
        img: PickupPayment,
        title: "03",
        subTitle: "Car pick up & payment",
        description: "We will transfer the amount directly to your bank account before your car is picked up"
    }
];
